import React from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Translate, getTranslation } from "orion-components/i18n";
import { useSelector, useDispatch } from "react-redux";

const EntityDelete = ({ closeDialog, name, id, deleteShape }) => {
	const dialog = useSelector((state) => state.appState?.dialog?.openDialog || "");

	const dispatch = useDispatch();

	const handleClose = () => {
		dispatch(closeDialog("shapeDeleteDialog"));
	};

	const handleConfirmDelete = () => {
		dispatch(deleteShape(id, name));
		handleClose();
	};

	const actions = [
		<Button variant="text" color="primary" onClick={handleClose} key="cancel-action-button" data-testid="entity-delete-cancel-button">
			{getTranslation("global.profiles.entityProfile.entityDelete.cancel")}
		</Button>,
		<Button variant="text" color="primary" onClick={handleConfirmDelete} key="delete-action-button" data-testid="entity-delete-confirm-button">
			{getTranslation("global.profiles.entityProfile.entityDelete.delete")}
		</Button>
	];

	return (
		<Dialog
			data-testid="entity-delete-dialog"
			open={dialog === "shapeDeleteDialog"}
			sx={{
				padding: "24px"
			}}
			onRequestClose={handleClose}
		>
			<DialogContent
				sx={{
					maxWidth: "500px",
					color: "#fff"
				}} data-testid="orion-components-profiles-entity-profile-components-entity-delete-dialog-content"
			>
				<div className="dialog-first-section" data-testid="orion-components-profiles-entity-profile-components-entity-delete-div">
					<Translate value="global.profiles.entityProfile.entityDelete.confirmationText" />
				</div>
			</DialogContent>

			<DialogActions data-testid="orion-components-profiles-entity-profile-components-entity-delete-dialog-actions">{actions}</DialogActions>
		</Dialog>
	);
};

export default EntityDelete;
